import api from './api';
import type { AiApp } from './mcpConnectionsService';

export interface OAuthConsentDetails {
  requestId: string;
  clientName: string | null;
  app: AiApp;
  scopes: string[];
  expiresAt: string;
  /** Whether THIS user may decide (MANAGE_EXTERNAL_AI in the active workspace). */
  canApprove: boolean;
}

/**
 * Consent step of the self-hosted OAuth flow: an external AI app's /authorize
 * request lands on /oauth/consent, which reads the pending request here and
 * posts the user's decision back. The response's redirect_url returns the
 * browser to the requesting app.
 */
export const oauthConsentService = {
  getDetails: async (requestId: string): Promise<OAuthConsentDetails> => {
    const { data } = await api.get(`/api/oauth/consent/${encodeURIComponent(requestId)}`, {
      silenceToast: true,
    });
    return data;
  },
  decide: async (
    requestId: string,
    action: 'approve' | 'deny',
  ): Promise<{ redirect_url: string }> => {
    const { data } = await api.post('/api/oauth/consent', { request_id: requestId, action });
    return data;
  },
};
